import * as React from 'react';
import { SVGProps } from 'react';
const FantasticEmoji = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_23_382)">
      <path
        d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
        fill="url(#paint0_radial_23_382)"
      />
      <path
        d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
        fill="url(#paint1_radial_23_382)"
      />
      <path
        d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
        fill="url(#paint2_radial_23_382)"
        fillOpacity={0.6}
      />
      <path
        d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
        fill="url(#paint3_radial_23_382)"
      />
      <path
        d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
        fill="url(#paint4_radial_23_382)"
      />
      <path
        d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
        fill="url(#paint5_radial_23_382)"
      />
      <path
        d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
        fill="url(#paint6_radial_23_382)"
      />
      <circle cx={9.01705} cy={13.4205} r={4.6733} fill="url(#paint7_radial_23_382)" />
      <circle cx={19.2443} cy={13.9432} r={4.24431} fill="url(#paint8_radial_23_382)" />
      <path
        d="M10.4191 16.2244C12.742 16.2244 14.6251 14.3414 14.6251 12.0185C14.6251 9.69557 12.742 7.8125 10.4191 7.8125C8.09621 7.8125 6.21313 9.69557 6.21313 12.0185C6.21313 14.3414 8.09621 16.2244 10.4191 16.2244Z"
        fill="white"
      />
      <path
        d="M21.5683 16.3011C23.9123 16.3011 25.8126 14.4009 25.8126 12.0568C25.8126 9.71274 23.9123 7.8125 21.5683 7.8125C19.2242 7.8125 17.324 9.71274 17.324 12.0568C17.324 14.4009 19.2242 16.3011 21.5683 16.3011Z"
        fill="white"
      />
      <path
        d="M11 15C12.6569 15 14 13.6569 14 12C14 10.3431 12.6569 9 11 9C9.34315 9 8 10.3431 8 12C8 13.6569 9.34315 15 11 15Z"
        fill="url(#paint9_linear_23_382)"
      />
      <path
        d="M21 15C22.6569 15 24 13.6569 24 12C24 10.3431 22.6569 9 21 9C19.3431 9 18 10.3431 18 12C18 13.6569 19.3431 15 21 15Z"
        fill="url(#paint10_linear_23_382)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4001 18.2001C10.8419 17.8687 11.4687 17.9582 11.8001 18.4001C12.1094 18.8125 13.5118 20.0001 16.0001 20.0001C18.4883 20.0001 19.8907 18.8125 20.2001 18.4001C20.5314 17.9582 21.1582 17.8687 21.6001 18.2001C22.0419 18.5314 22.1314 19.1582 21.8001 19.6001C21.1094 20.5209 19.1118 22.0001 16.0001 22.0001C12.8883 22.0001 10.8907 20.5209 10.2001 19.6001C9.86869 19.1582 9.95823 18.5314 10.4001 18.2001Z"
        fill="url(#paint11_radial_23_382)"
      />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_23_382"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(25.5 9) rotate(131.878) scale(38.9487)"
      >
        <stop stopColor="#FFF478" />
        <stop offset={0.474827} stopColor="#FFB02E" />
        <stop offset={1} stopColor="#F70A8D" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_23_382"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16 12.5) rotate(101.31) scale(17.8466 22.8581)"
      >
        <stop offset={0.787821} stopColor="#F59639" stopOpacity={0} />
        <stop offset={0.972509} stopColor="#FF7DCE" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_23_382"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(18 14) rotate(135) scale(41.0122)"
      >
        <stop offset={0.314853} stopOpacity={0} />
        <stop offset={1} />
      </radialGradient>
      <radialGradient
        id="paint3_radial_23_382"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16 17) rotate(77.692) scale(28.1469)"
      >
        <stop offset={0.507903} stopColor="#7D6133" stopOpacity={0} />
        <stop offset={1} stopColor="#715B32" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_23_382"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.5 16.5) rotate(55.7131) scale(13.3135 9.65032)"
      >
        <stop stopColor="#FFB849" />
        <stop offset={1} stopColor="#FFB847" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint5_radial_23_382"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(20.5 18) rotate(9.86581) scale(11.6726)"
      >
        <stop stopColor="#FFA64B" />
        <stop offset={0.900412} stopColor="#FFAE46" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint6_radial_23_382"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(17.5 15) rotate(43.9708) scale(59.0529)"
      >
        <stop offset={0.185425} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.4} />
      </radialGradient>
      <radialGradient
        id="paint7_radial_23_382"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(12.6518 9.7857) rotate(135) scale(9.10579 4.71285)"
      >
        <stop stopColor="#392108" />
        <stop offset={1} stopColor="#C87928" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="paint8_radial_23_382"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(22.5454 10.642) rotate(135) scale(7.66968 4.32966)"
      >
        <stop stopColor="#392108" />
        <stop offset={1} stopColor="#C87928" stopOpacity={0} />
      </radialGradient>
      <linearGradient
        id="paint9_linear_23_382"
        x1={16.5}
        y1={8}
        x2={15.5}
        y2={15}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#553B3E" />
        <stop offset={1} stopColor="#3D2432" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_23_382"
        x1={16.5}
        y1={8}
        x2={15.5}
        y2={15}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#553B3E" />
        <stop offset={1} stopColor="#3D2432" />
      </linearGradient>
      <radialGradient
        id="paint11_radial_23_382"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.0001 17.0001) rotate(90) scale(5.5 8.41855)"
      >
        <stop offset={0.34763} stopColor="#241A1A" />
        <stop offset={0.628228} stopColor="#57444A" />
        <stop offset={1} stopColor="#4E2553" />
        <stop offset={1} stopColor="#502A56" />
      </radialGradient>
      <clipPath id="clip0_23_382">
        <rect width={32} height={32} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default FantasticEmoji;
